import {API_URL} from "../../components/config/BaseUrl";

export const PAYMENTS_URL = `${API_URL}/getpaymentrecord`;